/**
 * Returns the latest date from a list of dates.
 *
 * @param dates - A list of Date objects.
 * @returns The latest date from the provided dates.
 */
export const getMaxDate = (...dates: [Date, ...Date[]]): Date => {
    return dates.reduce((maxDate, date) => (date > maxDate ? date : maxDate));
};
